module.exports = __webpack_public_path__ + "static/img/p-2.7f6ebb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-2.png
// module id = vwCi
// module chunks = 0